import { TTranscription } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentDetailCard/components/BroadcastScheduleProgramBodySegmentDetailCardBodySegmentTranscription';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { usePatchSegmentTranscription } from '@/features/segments/api/patch-segment-transcription';

import { Transcription } from '../Transcription/Transcription';
import { TranscriptionId } from '../Transcription/types';

export type SegmentTranscriptionProps = {
  transcriptions: TTranscription;
  transcriptionId?: TranscriptionId;
  seconds?: number;
  textToHighlight?: string;
  searchTextToHighlight?: string;
  setSelectedMention?: (mentionId: string) => void;
  onSelection?: (selection: string) => void;
};

export const SegmentTranscription = ({
  transcriptions,
  seconds = 0,
  textToHighlight,
  searchTextToHighlight,
  setSelectedMention,
  onSelection,
}: SegmentTranscriptionProps) => {
  const { mutate: updateSegmentTranscription } = usePatchSegmentTranscription();
  const { activeSegment } = useBroadcastScheduleProgram();

  return (
    <Transcription
      transcriptions={transcriptions}
      seconds={seconds}
      textToHighlight={textToHighlight}
      searchTextToHighlight={searchTextToHighlight}
      setSelectedMention={setSelectedMention}
      onSelection={onSelection}
      itemStartDatetime={activeSegment?.start_datetime}
      onUpdate={(transcriptionId, data) => {
        updateSegmentTranscription({
          id: transcriptionId,
          body: {
            asr_recognition_results: data.asrRecognitionResults,
          },
        });
      }}
    />
  );
};
